/** @jsx jsx */
import { FC } from 'react'
import { jsx } from '@emotion/core'

type Props = {}

const ErrorInline: FC<Props> = ({ children }) => {
	return (
		<div
			css={{
				borderLeft: `0.25rem solid red`,
				paddingLeft: '1rem',
				color: 'red',
			}}
		>
			{children}
		</div>
	)
}

export default ErrorInline
